import React from "react";

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p>Chargement...</p>
    </div>
  );
};

export default Loading;